__turbopack_context__.v({
  "bookmarkItem": "BookmarkItem-module__Qz-giq__bookmarkItem",
  "bookmarkItemNoPadding": "BookmarkItem-module__Qz-giq__bookmarkItemNoPadding",
  "bookmarkLink": "BookmarkItem-module__Qz-giq__bookmarkLink",
});
